/**
 * One numbered cluster of the settings panel — a step on a dive-planning
 * checklist rather than an undifferentiated wall of chips. The number is
 * cosmetic, not a wizard: every section is always visible and editable.
 */

import type { ReactNode } from "react";

interface SectionProps {
  index: string;
  title: string;
  note?: string;
  children: ReactNode;
}

export function Section({ index, title, note, children }: SectionProps) {
  return (
    <section className="rounded-[2px] border border-slate-line bg-field/40 p-3.5">
      <div className="mb-3 flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1 border-b border-slate-line pb-1.5">
        <h2 className="flex items-baseline gap-2 font-display text-[16px] font-bold uppercase tracking-[0.08em] text-graphite">
          <span className="text-graphite-2">{index}</span>
          {title}
        </h2>
        {note && <span className="text-[11px] leading-tight text-graphite-2">{note}</span>}
      </div>
      <div className="grid gap-4">{children}</div>
    </section>
  );
}
